"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStore = void 0;
var util_1 = require("./util");
var GlobalStore = /** @class */ (function () {
    function GlobalStore(contents, breadcrumbsLimit) {
        this.contents = contents;
        this.breadcrumbsLimit = breadcrumbsLimit;
    }
    GlobalStore.create = function (contents, breadcrumbsLimit) {
        return new GlobalStore(contents, breadcrumbsLimit);
    };
    GlobalStore.prototype.available = function () {
        return true;
    };
    GlobalStore.prototype.getContents = function (key) {
        var value = key ? this.contents[key] : this.contents;
        // `clone` keeps JSON round trip semantics but tolerates values a bare
        // round trip throws on -- notably circular references, which arrive via
        // context or breadcrumb metadata the host application controls.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (0, util_1.clone)(value);
    };
    GlobalStore.prototype.setContext = function (context) {
        this.contents.context = (0, util_1.merge)(this.contents.context, context || {});
    };
    GlobalStore.prototype.setEventContext = function (eventContext) {
        this.contents.eventContext = (0, util_1.merge)(this.contents.eventContext, eventContext || {});
    };
    GlobalStore.prototype.clearEventContext = function () {
        this.contents.eventContext = {};
    };
    GlobalStore.prototype.addBreadcrumb = function (breadcrumb) {
        if (this.contents.breadcrumbs.length == this.breadcrumbsLimit) {
            this.contents.breadcrumbs.shift();
        }
        this.contents.breadcrumbs.push(breadcrumb);
    };
    GlobalStore.prototype.clear = function () {
        this.contents.context = {};
        this.contents.eventContext = {};
        this.contents.breadcrumbs = [];
    };
    GlobalStore.prototype.run = function (callback) {
        return callback();
    };
    return GlobalStore;
}());
exports.GlobalStore = GlobalStore;
//# sourceMappingURL=store.js.map